module.exports = __webpack_public_path__ + "media/images/pokerroom/redstar/step2-pict02-300e6320d0efa6b54dc109b9e575a573.jpg";